module.exports = "../images/icons-race-details/Download.svg";